module.exports = __webpack_public_path__ + "img/115029.da95dbad.png";